import { render, staticRenderFns } from "./AgreeApplyResultPage.vue?vue&type=template&id=214e1478&scoped=true&"
import script from "./AgreeApplyResultPage.vue?vue&type=script&lang=ts&"
export * from "./AgreeApplyResultPage.vue?vue&type=script&lang=ts&"
import style0 from "./AgreeApplyResultPage.vue?vue&type=style&index=0&id=214e1478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e1478",
  null
  
)

export default component.exports